import React from 'react'
import { compose } from 'react-apollo'
import { Container } from '@scentregroup/ui'
import classNames from 'classnames'
import PropTypes from 'prop-types'
import NationalHeader from '../components/national-header'
import CentreSelector from '../components/centre-selector'
import Promotion from '../components/promotion'
import NationalFooter from '../components/national-footer'
import withNationalPromotion from '../containers/with-national-promotion'
import withCentreSelector from '../containers/with-centre-selector'
import { promotionType } from '../types'
import analyticsUtils from '../helpers/analytics-utils'
import ContentGroup from '../components/content-group'
import { CountryContext, AgentInfoContext } from '../context'
import pagesHoc from './pages-hoc'
import style from './index.scss'

const Index = ({ centres, homePageInfo, promotion }) => (
  <Container className={classNames(style.homeBody)}>
    <AgentInfoContext.Consumer>
      {({ isMobile }) => (
        <CountryContext.Consumer>
          {country => (
            <>
              <NationalHeader promotionalUrl={promotion.callToActionAddress} />
              <CentreSelector
                centres={centres}
                homePageInfo={homePageInfo}
                isNZ={country !== 'Australia'}
                isMobile={isMobile}
              />
            </>
          )}
        </CountryContext.Consumer>
      )}
    </AgentInfoContext.Consumer>
    <ContentGroup angleOrigin="top-left" color="Grey" key="0">
      {promotion && (
        <Promotion
          {...promotion}
          eventCategory={analyticsUtils.categories.GIFTCARD_CLICK}
          eventAction={analyticsUtils.actions.GIFTCARD_NAT_HOME}
        />
      )}
    </ContentGroup>
    <NationalFooter />
  </Container>
)

Index.propTypes = {
  centres: PropTypes.arrayOf(PropTypes.object),
  homePageInfo: PropTypes.object,
  promotion: promotionType,
}

Index.defaultProps = {
  centres: [],
  homePageInfo: {},
}

const getHomepageStructuredData = ({ url }) =>
  url
    ? {
        '@context': 'http://schema.org',
        '@type': 'WebSite',
        url,
        potentialAction: {
          '@type': 'SearchAction',
          target: `${url}search?q={search_term_string}`,
          'query-input': 'required name=search_term_string',
        },
      }
    : null

const getMetaData = ({ centres, canonical }) => ({
  title: `Westfield ${centres[0].country} - Visit Our Centres or Browse Online`,
  description:
    'Westfield is your one-stop destination for shopping, leisure and entertainment. Discover 1000s of popular retailers in fashion, home, decor and more.',
  schema: getHomepageStructuredData({ url: canonical }),
})

export default compose(
  withCentreSelector,
  withNationalPromotion
)(pagesHoc(Index, getMetaData))
